export default __webpack_public_path__ + "static/media/84.02f67275.png";